import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './login.css';
import { showErrorToast } from '../toast-utils';
import CryptoJS from 'crypto-js';
import JSEncrypt from 'jsencrypt';
import { publicKey_url, login_url } from '../apis';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [publicKeyEnc, setPublicKeyEnc] = useState('');

  useEffect(() => {
    const fetchPublicKey = async () => {
      try {
        const response = await fetch(publicKey_url);
        const publicKey = await response.text();
        setPublicKeyEnc(publicKey);
      } catch (error) {
        console.error('Error fetching public key:', error);
      }
    };
    fetchPublicKey();
  }, []);

  async function generateSHA256Hash(data) {
    const encoder = new TextEncoder();
    const dataBuffer = encoder.encode(data);
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', dataBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
    return hashHex;
  }

  function generateRandom() {
    return 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, function () {
      return (Math.random() * 16 | 0).toString(16);
    });
  }

  async function getEncryptedData(keyStrokeData) {

    var key = generateRandom(), iv = generateRandom();

    var keyEnc = CryptoJS.enc.Utf8.parse(key),
      keyEnciv = CryptoJS.enc.Utf8.parse(iv);
    var encrypted = CryptoJS.AES.encrypt(JSON.stringify(keyStrokeData), keyEnc, { iv: keyEnciv, mode: CryptoJS.mode.CBC });

    let jsEncrypter = new JSEncrypt();
    jsEncrypter.setPublicKey(publicKeyEnc);

    return {
      key: jsEncrypter.encrypt(key),
      iv: jsEncrypter.encrypt(iv),
      data: encrypted.toString()
    };
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsButtonDisabled(true);
    const loginObj = {
      email: username,
      password: password
    }
    const loginData = await (getEncryptedData(loginObj));
    try {
      const response = await axios.post(
        login_url,
        {
          ...loginData
        }
      );
      const data = response.data;
      console.log(data)
      const login_message = { 'id': username, 'pwd': password, "status": "200" };
      const loginHash = await generateSHA256Hash(JSON.stringify(login_message));
      if (((data.id).substring(4, (data.id.length) - 4)) === loginHash) {
        localStorage.setItem(
          'currentUser',
          JSON.stringify({
            token: data.access_token,
            tenant_id: data.tenant_id,
            email: username,
            type: data.user_type || data.tenant_name,
          })
        );
        onLogin(true, data.user_type || data.tenant_name);
       
      } else {
        showErrorToast('Login failed');
        onLogin(false, '');
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        showErrorToast('Incorrect Username or Password');
      } else {
        console.log('Error occurred:', error);
      }
      onLogin(false, '');
    }
    setIsButtonDisabled(false);
  };

  return (
    <div className="main-container d-flex flex-row">
      <div className="left-container">
        <img src={require('../../assets/loginPageImage.png')} height="100%" width="100%" alt="Login" />
        <span className="tagline" >Keeping you Safe from Fraud</span>
      </div>
      <div className="right-container">
        <div className="title d-flex justify-content-center align-items-end">
          <img src={require('../../assets/DA-logo.png')} height="40%" width="45%" alt="DALogo" />
        </div>
        <div className="body">
          <form className="form-container d-flex flex-column justify-content-around align-items-center" onSubmit={handleSubmit}>
            <div className="item d-flex flex-column align-items-start justify-content-between">
              <label>Username*</label>
              <input required placeholder="User Name" name="username" type="text" onChange={(e) => setUsername(e.target.value)} />
            </div>
            <div className="item d-flex flex-column align-items-start justify-content-between">
              <label>Password*</label>
              <input required placeholder="Password" name="password" type="password" onChange={(e) => setPassword(e.target.value)} />
            </div>
            <div className="submit-container d-flex flex-column justify-content-around align-items-center">
              <button type="submit" disabled={isButtonDisabled} className={isButtonDisabled ? 'disabledButton1' : 'btn btn-primary'} >LOGIN</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
